import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ServicesIndex from "@/pages/ServicesIndex";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminArticles from "@/pages/AdminArticles";

const RouterBridge = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.__navigate = navigate;
    return () => {
      window.__navigate = null;
    };
  }, [navigate]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LangProvider>
      <BrowserRouter>
        <RouterBridge />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/uslugi" element={<ServicesIndex />} />
          <Route path="/uslugi/:slug" element={<ServicePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/articles" element={<AdminArticles />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </LangProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121418", border: "1px solid #272A30", color: "#F3F4F6" } }} />
    </div>
  );
}

export default App;
